<template>
    <el-dialog :visible.sync="dialogValue" title="方案组复制"
               custom-class="group-dialog"
               :append-to-body="true"
               class="global-dialog"
               width="700px"
               :close-on-click-modal="false">
       <div class="g-d-box">
           <template v-if="dataList.length > 0">
               <div class="proj-box">
                   <el-select v-model="projectId" placeholder="请选择项目" @change="onProjectChange" filterable clearable style="width:100%">
                       <el-option v-for="(item, index) in  projects" :label="item.name" :value="item.id" :key="index">{{item.name}}</el-option>
                   </el-select>
                   <el-select  v-model="templateIds" placeholder="请选择模板" filterable multiple clearable style="width:100%;margin-top: 10px">
                       <el-option v-for="(item, index) in  templateList"
                                  :label="item.name"
                                  :value="item.id"
                                  :key="index">{{item.name}}</el-option>
                   </el-select>
               </div>
               <ul>
                   <li v-for="(sItem, sIdx) in dataList" :key="sIdx">
                       <div class="as-content">
                           <div class="as-body">
                               <el-checkbox v-model="sItem.checked" size="medium"></el-checkbox>
                               <div class="hover-bg" @click="onChecked(sItem)"></div>
                               <img class="pt-img" :src="sItem.coverUrl" v-if="data.type === group_type_pt"/>
                               <tpl-group-editor v-else :value="sItem.json" :edit="false"
                                                 :scale="sItem.scale"></tpl-group-editor>
                           </div>
                       </div>
                   </li>
               </ul>
           </template>
           <p v-else class="c-center">无方案组数据</p>
       </div>
        <div slot="footer">
            <el-button @click="onCancel">取消</el-button>
            <el-button type="primary" @click="onSave" :loading="saveLoading" v-if="dataList.length > 0">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import groupService from '../../../request/service/group-service'
    import templateService from '../../../request/service/template-service'
    import {group_type_pt, group_type_mk, template_type_single} from '@/const';
    import tplGroupEditor from '../../templateGroup/editor/tpl-editor-area';
    import util from '@/util';
    export default {
        components: {tplGroupEditor},
        props: {
            value: {type: Boolean, default: false},
            data: {
                type: Object, default() {
                    return {tplType: '', type: '', projectId: '', templateIds: null}
                }
            }
        },
        data() {
            return {
                template_type_single,
                group_type_pt,
                saveLoading: false,
                dataList: [],
                projectId: null,
                templateList: [],
                templateIds: []
            }
        },
        computed: {
            dialogValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
            projects () {
                return this.$store.state.app.loginUser.projectItems;
            },
        },
        watch: {
            value(v) {
                if (v) {
                    this.init();
                } else {
                    this.dataList = [];
                }
            }
        },
        created() {
        },
        methods: {
            init(){
                this.getData();
            },
            getData(){
                let params = this.data;
                groupService.getGroupList(params).then(({list}) => {
                    if (list && list.length > 0 && params.type === group_type_mk) {
                        list.forEach((item) => {
                            let width = item.json.width;
                            let height = item.json.height;
                            item.scale = util.getScale(170, 100, width, height);
                        });
                    }
                    this.dataList = list;
                });
            },
            onProjectChange(projectId){
                this.templateIds = [];
                this.templateList = [];
                templateService.getTemplateListByProjectId(projectId).then((data) => {
                    this.templateList = data.filter((item) => {
                        return item.type === this.data.tplType
                    });
                })
            },
            onCancel(){
                this.$emit('input', false);
            },
            getGroupIds(){
                let arr = [];
               this.dataList.forEach((item) => {
                  if(item.checked){
                      arr.push(item.id);
                  }
              });
                return arr;
            },
            onSave(){
                let ids = this.templateIds;
                if(ids === null || ids.length === 0){
                    this.$message.error('请选择模板');
                    return
                }
                let groupIds = this.getGroupIds();
                if(groupIds.length === 0){
                    this.$message.error('请选择方案组');
                    return;
                }
                this.saveLoading = true;
                templateService.copyTemplateGroup(groupIds, ids, this.data.type).then(() => {
                        this.$message.success('复制成功');
                }).finally(() => {
                    this.saveLoading = false;
                    this.$emit('input', false);
                });
            },
            onChecked(item){
                if(item.hasOwnProperty('checked')){
                    item.checked = !item.checked;
                } else {
                    this.$set(item, 'checked', true);
                }
            },
        }
    }
</script>

